import { FC } from 'react';
import styles from './VersionSticker.module.scss';

const VersionSticker: FC = () => {
  return <span className={styles.versionSticker}>Полная версия</span>;
};

export default VersionSticker;
